module.exports = __webpack_public_path__ + "static/media/tall-bg-tc.23a21b2b.jpg";